import React from 'react';
import {Box, Typography} from '@mui/material';

interface Props {
  status: string | null | undefined;
  hasDelay?: boolean;
}

const resolveStyle = (status: string | null | undefined, hasDelay?: boolean) => {
  const s = (status ?? '').toLowerCase();
  if (s.includes('cancel'))
    return {dot: '#c62828', text: '#b71c1c', bg: 'rgba(198,40,40,0.10)', border: 'rgba(198,40,40,0.25)'};
  if (s.includes('delay') || s.includes('atras')) {
    if (hasDelay === false) return null;
    return {dot: '#e65100', text: '#bf360c', bg: 'rgba(230,81,0,0.10)', border: 'rgba(230,81,0,0.25)'};
  }
  if (s.includes('time') || s.includes('normal') || s.includes('hora'))
    return {dot: '#2e7d32', text: '#1b5e20', bg: 'rgba(46,125,50,0.10)', border: 'rgba(46,125,50,0.25)'};
  return null;
};

const FlightStatusBadge = ({status, hasDelay}: Props) => {
  if (!status) return null;
  const style = resolveStyle(status, hasDelay);
  if (!style) return null;
  const {dot, text, bg, border} = style;
  return (
    <Box sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 0.65,
      px: 1.1,
      py: 0.5,
      borderRadius: '20px',
      bgcolor: bg,
      border: '1px solid',
      borderColor: border,
      flexShrink: 0,
    }}>
      <Box sx={{
        width: 7,
        height: 7,
        borderRadius: '50%',
        bgcolor: dot,
        flexShrink: 0,
        boxShadow: `0 0 0 2.5px ${dot}40`,
      }} />
      <Typography sx={{
        fontSize: '0.68rem',
        fontWeight: 700,
        letterSpacing: '0.07em',
        textTransform: 'uppercase',
        color: text,
        lineHeight: 1,
      }}>
        {status}
      </Typography>
    </Box>
  );
};

export default FlightStatusBadge;
